import * as React from 'react';
import ReactLoading from 'react-loading';

const Loader: React.SFC = () => {
    return <ReactLoading type="bubbles" color="lightgray" height={19} width={60} />
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.tsx